<!--
 * @Descripttion : 车况报告
 * @version      : 
 * @Author       : karl
 * @Date         : 2022-01-17 16:52:13
 * @LastEditors  : 
 * @LastEditTime : 
-->

<template>
    <div class="page" ref="page">
        <div class="head" v-if="nativetitle">
            <div class="back" @click="goback"></div>
            <div class="head-tit">车况报告</div>
        </div>
        <div style="height:44px;" v-if="nativetitle"></div>
        <img :src="reportImg">
    </div>
</template>
<script>
export default {
    components: {

    },
    data() {
        return {
            reportImg: '',
            nativetitle: false,
        }
    },
    filters: {

    },
    created() {
        this.reportImg = this.$route.query.img;
        if (this.$route.query.nativetitle == 1) {
            this.nativetitle = false;
        } else {
            this.nativetitle = true;
        }

    },
    mounted() {

    },
    methods: {
        goback() {
            location.href = "carwins://go?back";
        }
    },
}
</script>
<style lang="scss">
body {
    background-color: #f3f5f7;
}
</style>
<style lang="scss" scoped>
*,
*:before,
*:after {
    box-sizing: border-box;
    user-select: none;
}

.page {
    padding: 10px;

    img {
        width: 100%;
        display: block;
        margin: 0 auto;
    }

    .head {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        height: 44px;
        overflow: hidden;
        background-color: #fff;
        z-index: 99999;

        .head-tit {
            line-height: 44px;
            font-size: 14px;
            color: #ff7901;
            text-align: center;
            padding: 0 44;
        }

        .back {
            width: 44px;
            height: 44px;
            position: absolute;
            top: 0;
            left: 0;
            overflow: hidden;
        }

        .back:after {
            content: " ";
            display: inline-block;
            -webkit-transform: rotate(-135deg);
            transform: rotate(-135deg);
            border-width: 1px 1px 0 0;
            border-color: #ff7901;
            border-style: solid;
            height: 10px;
            width: 10px;
            position: relative;
            top: 15px;
            margin-left: 15px;
        }
    }
}
</style>